import { Container } from "react-bootstrap";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Main from "./components/Main";

function App() {
	return (
		<div className="App">
			{/* <FormExample /> */}
			<Container className="p-3">
				<Container className="p-5 mb-4 bg-light rounded-3">
					<BrowserRouter>
						<Routes>
							<Route path="/" element={<Main />}></Route>
							<Route path="/signup" element={<Signup />}></Route>
							<Route path="/login" element={<Login />}></Route>
							<Route path="/home" element={<Home />}></Route>
						</Routes>
					</BrowserRouter>
				</Container>
			</Container>
		</div>
	);
}

export default App;
